import React, { useState, useEffect } from 'react'
import { Box, Grid, Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

import { CityAutoComplete, DatePicker, Select } from './components'
import { useSelector } from 'react-redux'
import { add, getISODay, format } from 'date-fns'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { useCookies } from 'react-cookie'

const timeOptions = [
  {
    label: '06:00',
    value: '06:00'
  },
  {
    label: '06:30',
    value: '06:30'
  },
  {
    label: '07:00',
    value: '07:00'
  },
  {
    label: '07:30',
    value: '07:30'
  },
  {
    label: '08:00',
    value: '08:00'
  },
  {
    label: '08:30',
    value: '08:30'
  },
  {
    label: '09:00',
    value: '09:00'
  },
  {
    label: '09:30',
    value: '09:30'
  },
  {
    label: '10:00',
    value: '10:00'
  },
  {
    label: '10:30',
    value: '10:30'
  },
  {
    label: '11:00',
    value: '11:00'
  },
  {
    label: '11:30',
    value: '11:30'
  },
  {
    label: '12:00',
    value: '12:00'
  },
  {
    label: '12:30',
    value: '12:30'
  },
  {
    label: '13:00',
    value: '13:00'
  },
  {
    label: '13:30',
    value: '13:30'
  },
  {
    label: '14:00',
    value: '14:00'
  },
  {
    label: '14:30',
    value: '14:30'
  },
  {
    label: '15:00',
    value: '15:00'
  },
  {
    label: '15:30',
    value: '15:30'
  },
  {
    label: '16:00',
    value: '16:00'
  },
  {
    label: '16:30',
    value: '16:30'
  },
  {
    label: '17:00',
    value: '17:00'
  },
  {
    label: '17:30',
    value: '17:30'
  },
  {
    label: '18:00',
    value: '18:00'
  },
  {
    label: '18:30',
    value: '18:30'
  },
  {
    label: '19:00',
    value: '19:00'
  },
  {
    label: '19:30',
    value: '19:30'
  },
  {
    label: '20:00',
    value: '20:00'
  },
  {
    label: '20:30',
    value: '20:30'
  },
  {
    label: '21:00',
    value: '21:00'
  }
]

const useStyles = makeStyles((theme) => ({
  input: {
    background: 'white',
    height: 60,
    padding: '10px 15px',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '40px',
    color: '#002f3d',
    width: '100%',
    border: 'none',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      borderRight: '1px solid #002f3d'
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
      textAlign: 'center'
    },
    '&::-webkit-input-placeholder': { color: '#002f3d' },
    '&:focus': {
      boxShadow: '0 0 0 4px #83bffc inset',
      outline: 'none'
    }
  },
  submit: {
    border: 'none',
    background: '#5adae9',
    '&:hover': {
      background: '#4fbdc9'
    }
  }
}))

const getNextMonday = () => {
  const today = new Date()
  const offsetDays = 7 - getISODay(today) + 1 // 1 means Monday
  return add(today, { days: offsetDays })
}

const SearchForm = ({ match, ...props }) => {
  const { className, ...rest } = props
  const classes = useStyles()

  const [cookies, setCookie, removeCookie] = useCookies()

  const { params } = match
  const langcode1 = params.langcode ? params.langcode : 'en'
  const hourSymbol = ['da', 'sv', 'no'].includes(langcode1) ? 't' : 'h'

  const lengthOptions = [
    {
      label: `2${hourSymbol}`,
      value: '2'
    },
    {
      label: `3${hourSymbol}`,
      value: '3'
    },
    {
      label: `4${hourSymbol}`,
      value: '4'
    },
    {
      label: `5${hourSymbol}`,
      value: '5'
    },
    {
      label: `6${hourSymbol}`,
      value: '6'
    },
    {
      label: `7${hourSymbol}`,
      value: '7'
    },
    {
      label: `8${hourSymbol}`,
      value: '8'
    },
    {
      label: `9${hourSymbol}`,
      value: '9'
    },
    {
      label: `10${hourSymbol}`,
      value: '10'
    }
  ]

  // this langcode cannot be en
  const langcode = match.params.langcode

  const [places, setPlaces] = useState([])
  const [isPlacesLoading, setIsPlacesLoading] = useState(false)
  const [error, setError] = useState(null)

  const [cityValue, setCityValue] = useState(null)
  const [dateValue, setDateValue] = useState(getNextMonday())

  const [timeValue, setTimeValue] = useState('9:00')
  const [lengthValue, setLengthValue] = useState('8')
  const [peopleValue, setPeopleValue] = useState('')

  const { date, time, meetingLength, people, search } = useSelector(
    (state) => state.language.text
  )

  useEffect(() => {
    const loadVenues = async () => {
      setIsPlacesLoading(true)
      try {
        // const backendUrl = 'https://sandbox-api.meetingpackage.com/v2'

        let backendUrl = 'http://localhost:8750/v2'

        if (window.location.hostname === 'bookameeting.se') {
          backendUrl = 'https://api.meetingpackage.com/v2'
        }
        if (window.location.hostname === 'stage.bookameeting.se') {
          backendUrl = 'https://sandbox-api.meetingpackage.com/v2'
        }

        const { data } = await axios.get(`${backendUrl}/bookameeting/venues`)
        const dataWithLabel = data.map((datum) => ({
          ...datum,
          label: datum.name[langcode1]
            ? datum.name[langcode1]
            : datum.name['en']
        }))

        setPlaces(dataWithLabel)
      } catch (error) {
        setError(error)
      } finally {
        setIsPlacesLoading(false)
      }
    }

    loadVenues()
  }, [langcode1])

  return (
    <form
      // autocomplete="off"
      onSubmit={(e) => {
        e.preventDefault()

        const langPrefix = langcode ? `/${langcode}` : ''
        const delegates = peopleValue ? peopleValue : 0
        const duration = lengthValue ? lengthValue : 0
        const time = timeValue ? timeValue : '08:00'

        const cookieDateTime = `${format(dateValue, 'dd MMMM, yyy')} @ ${time}`

        setCookie(
          langcode ? `${langcode}_pref_dt` : 'en_pref_dt',
          cookieDateTime
        )
        setCookie('_pref_qty', delegates)
        setCookie('_pref_mt', duration)

        if (cityValue.type === 'venue') {
          window.location.href = encodeURI(
            `${langPrefix}/node/${cityValue.value}`
          )
        }
        if (cityValue.type === 'city') {
          setCookie('selectedCity', cityValue.label)

          window.location.href = encodeURI(
            `${langPrefix}/wlsearch?query&city_id=${cityValue.value}&delegates=${delegates}&duration=${duration}&index_id=venues_index&city=${cityValue.label}`
          )
        }
      }}>
      <Grid
        container
        className={classes.inputContainer}
        alignItems="center"
        justify="center"
        spacing={0}>
        <Grid item xs={12} md={3}>
          <CityAutoComplete
            inputProps={{ className: classes.input }}
            options={places}
            value={cityValue}
            onChange={setCityValue}></CityAutoComplete>
        </Grid>
        <Hidden xsDown>
          <Grid item xs={12} md={2}>
            <DatePicker
              placeholder={date}
              inputProps={{ className: classes.input }}
              value={dateValue}
              onChange={setDateValue}></DatePicker>
          </Grid>
          <Grid item xs={12} md={langcode1 !== 'en' ? 1 : 2}>
            <Select
              inputProps={{ className: classes.input }}
              options={timeOptions}
              placeholder={time}
              value={timeValue}
              onChange={setTimeValue}></Select>
          </Grid>
          <Grid item xs={12} md={2}>
            <Select
              inputProps={{ className: classes.input }}
              options={lengthOptions}
              placeholder={meetingLength}
              valuePostfix={` ${hourSymbol}`}
              value={lengthValue}
              onChange={setLengthValue}></Select>
          </Grid>
        </Hidden>
        <Grid item xs={12} md={langcode1 !== 'en' ? 2 : 1}>
          <input
            className={classes.input}
            placeholder={people}
            type="number"
            min="0"
            value={peopleValue}
            onChange={(e) => setPeopleValue(e.target.value)}></input>
        </Grid>
        <Grid item xs={12} md={2}>
          <button type="submit" className={clsx(classes.input, classes.submit)}>
            {search}
          </button>
        </Grid>
      </Grid>
    </form>
  )
}

export default withRouter(SearchForm)
